<template>
  <article class="p-contact">
    <section class="s-text l-3">
      <h2 v-html="title"></h2>
      <h3 v-html="paragraph"></h3>
      <ul>
        <li>Adtelier srl</li>
        <li>Via Balzaretti, 36</li>
        <li>Milano - Italy</li>
      </ul>
      <ul>
        <li>Contatti</li>
        <li>
          T:
          <a href="tel:00390272008028" data-cta>
            <u>0039 0272008028</u>
          </a>
        </li>
        <li>
          E:
          <a href="mailto:info@adtelier.it" data-cta>
            <u>info@adtelier.it</u>
          </a>
        </li>
      </ul>
    </section>
    <Form />
    <footer id="a-footer">
      <div class="footer-copy">
        <span>
          Adtelier &copy; . IT10556780962 .
          <a target="_blank" :href="lang === 'en' ? 'https://www.iubenda.com/privacy-policy/72080415' : 'https://www.iubenda.com/privacy-policy/98087786'" data-cta>
            <u>Privacy</u>
          </a> .
          <a target="_blank" :href="lang === 'en' ? 'https://www.iubenda.com/privacy-policy/72080415/cookie-policy' : 'https://www.iubenda.com/privacy-policy/98087786/cookie-policy'" data-cta>
            <u>Cookies</u>
          </a>
        </span>
      </div>
    </footer>
  </article>
</template>

<script>
import axios from 'axios';
import { app, slider } from '@/utils/store';

import Form from '@/components/form/form.vue';

export default {
  components: {
    Form,
  },

  data() {
    return {
      lang: app.language,
      title: this.title,
      paragraph: this.paragraph,
    };
  },

  created() {
    axios.get('/json/contact.json').then((response) => {
      if (app.language === 'it') {
        this.title = response.data.it.title;
        this.text_1_h3 = response.data.it.text_1_h3;
      } else {
        this.title = response.data.en.title;
        this.paragraph = response.data.en.paragraph;
      }
    });
  },

  mounted() {
    slider.next = 1;
    slider.current = 0;

    app.contact = true;

    document.getElementById('a-logo').style.pointerEvents = '';
    document.getElementById('a-slider').style.visibility = 'hidden';
  },
};
</script>
